import { Stack, Typography } from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ReactNode } from 'react';

import { LoadingIndicatorIcon } from '@/components/loaders/LoadingIndicatorIcon';

interface ActionDialogProps {
    isOpen: boolean;
    isLoading?: boolean;
    onConfirm: () => void;
    onReject: () => void;
    message: ReactNode | ReactNode[];
    title: string;
    confirmLabel?: string;
    confirmButtonProps?: ButtonProps;
    rejectLabel?: string;
    rejectButtonProps?: ButtonProps;
}

export const ActionDialog = ({
    isOpen,
    isLoading,
    onConfirm,
    onReject,
    title,
    message,
    confirmLabel = 'Confirm',
    confirmButtonProps,
    rejectLabel = 'Dismiss',
    rejectButtonProps,
}: ActionDialogProps) => {
    const messages = Array.isArray(message) ? message : [message];
    return (
        <Dialog
            open={isOpen}
            onClose={onReject}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText component="div" id="alert-dialog-description">
                    <Stack component="ul" sx={{ gap: 1, px: 0, my: 0 }}>
                        {messages.map((msg, i) => (
                            <Typography
                                component="li"
                                key={`${msg}-${i}`}
                                variant="body2"
                                sx={{ listStyleType: 'none' }}
                            >
                                {msg}
                            </Typography>
                        ))}
                    </Stack>
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ mr: 1, mb: 1 }}>
                <LoadingIndicatorIcon isLoading={!!isLoading} />
                <Button onClick={onReject} {...rejectButtonProps} disabled={isLoading}>
                    {rejectLabel}
                </Button>
                <Button
                    onClick={onConfirm}
                    autoFocus
                    variant="outlined"
                    color="success"
                    {...confirmButtonProps}
                    disabled={isLoading}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
